<template>
  <d-container fluid class="px-3 main-content-container">
    <d-form-row>
      <!-- CEP -->
      <d-col md="2"  class="form-group">
        <label for="inputCEP">CEP</label>
        <masked-input
          type="text"
          class="text-left form-control"
          id="inputCEP"
          placeholder="00.000-000"
          :mask="[/\d/, /\d/,'.', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/]"
          :guide="false"
          v-model="model.zipcode"
          @blur="consultaCEP(model.zipcode)"
          :readonly="isRepresentative"
        ></masked-input>
      </d-col>
      <!-- Logradouro -->
      <d-col md="8" class="form-group">
        <label for="feInputEndereco">Logradouro</label>
        <d-form-input
          type="text"
          id="feInputEndereco"
          placeholder="Rua,Av,Travessa"
          v-model="model.street"
          @change="capitalizeAddressInput('street')"
          :readonly="isRepresentative"
        />
      </d-col>

      <!-- Numero -->
      <d-col md="2" class="form-group">
        <label for="feInputNumero">Número</label>
        <d-form-input type="text" id="feInputNumero" placeholder="Número" v-model="model.number" :readonly="isRepresentative"/>
      </d-col>

    </d-form-row>

    <d-form-row>

      <!-- Complemento -->
      <d-col md="3" class="form-group">
        <label for="feInputComplemento">Complemento</label>
        <d-form-input
          type="text"
          id="feInputComplemento"
          v-model="model.address2"
          placeholder="apartamento,bloco,etc..."
          @change="capitalizeAddressInput('address2')"
          :readonly="isRepresentative"
        />
      </d-col>

      <!-- Bairro -->
      <d-col md="3" class="form-group">
        <label for="feInputBairro">Bairro</label>
        <d-form-input
          type="text"
          id="feInputBairro"
          v-model="model.district"
          @change="capitalizeAddressInput('district')"
          :readonly="isRepresentative"
        />
      </d-col>

      <!-- Cidade -->
      <d-col md="4" class="form-group">
        <label for="feInputCidade">Cidade</label>
        <d-form-input
          type="text"
          id="feInputCidade"
          v-model="model.city"
          @change="capitalizeAddressInput('city')"
          :readonly="isRepresentative"
        />
      </d-col>

      <!-- Estado -->
      <d-col md="2" class="form-group">
        <label for="feInputEstado">Estado</label>
        <select-state :model.sync="model.state" :readonly="isRepresentative"/>
      </d-col>

    </d-form-row>

  </d-container>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import MaskedInput from 'vue-text-mask';
import SelectState from '_shared/SelectState.vue';
import ResellerService from '_services/rest/modules/reseller';
import { capitalize } from '_utils/string';
import { ADDRESS } from './ResellerModel';

export default {
  name: 'addresses',
  components: {
    MaskedInput,
    SelectState,
  },
  props: {
    model: {
      type: Object,
      default: () => ({ ...ADDRESS }),
      required: true,
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    isRepresentative() {
      const { user } = this.$store.state.user;
      if (user && user.settings.type.slug === 'representative') {
        return true;
      }
      return false;
    },
  },
  watch: {
    model: {
      handler(val) {
        Events.$emit('update:model', val);
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions([
      'activeAlert',
      'getResellerAddress',
    ]),
    capitalizeAddressInput(field) {
      this.model[field] = capitalize(this.model[field]);
    },
    consultaCEP(cep) {
      ResellerService.getCep(cep)
        .then(response => {
          this.model.city = response.localidade;
          this.model.state = response.uf;
          this.model.street = response.logradouro;
          this.model.district = response.bairro;
          this.$emit('changeCep', this.model);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.tab-pane {
  border: 1px solid #e1e5eb;
  border-top: 0;
}
</style>
